// Shared animation configuration for Leader Programme page
// Spotify Wrapped-inspired: bold, energetic, spring physics

// Spring physics for bouncy feel
export const SPRING_BOUNCE = { type: "spring", stiffness: 300, damping: 20 };
export const SPRING_SNAPPY = { type: "spring", stiffness: 400, damping: 25 };
export const SPRING_GENTLE = { type: "spring", stiffness: 200, damping: 20 };

// Fast, snappy ease
export const EASE_FAST = { duration: 0.4, ease: "easeOut" };

// Section entrance: scale + fade with spring
export const sectionVariants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: SPRING_GENTLE,
  },
};

// Hero word animation: scale + blur effect
export const wordVariants = {
  hidden: { opacity: 0, scale: 0.8, filter: "blur(10px)" },
  visible: {
    opacity: 1,
    scale: 1,
    filter: "blur(0px)",
    transition: SPRING_BOUNCE,
  },
};

// Container for staggered children
export const staggerContainerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1,
    },
  },
};

// Individual staggered item with bounce
export const staggerItemVariants = {
  hidden: { opacity: 0, y: 30, scale: 0.9 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: SPRING_BOUNCE,
  },
};

// Slide in from left
export const slideInLeftVariants = {
  hidden: { opacity: 0, x: -60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: SPRING_SNAPPY,
  },
};

// Slide in from right
export const slideInRightVariants = {
  hidden: { opacity: 0, x: 60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: SPRING_SNAPPY,
  },
};

// Card flip animation
export const cardFlipVariants = {
  hidden: { opacity: 0, rotateY: -15, scale: 0.9 },
  visible: {
    opacity: 1,
    rotateY: 0,
    scale: 1,
    transition: SPRING_BOUNCE,
  },
};

// Pop in with rotation (for headshots)
export const popInVariants = {
  hidden: { opacity: 0, scale: 0, rotate: -15 },
  visible: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    transition: SPRING_BOUNCE,
  },
};

// Scale up entrance
export const scaleUpVariants = {
  hidden: { opacity: 0, scale: 0.5 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: SPRING_BOUNCE,
  },
};

// Image reveal with zoom
export const imageRevealVariants = {
  hidden: { scale: 1.2, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: { ...SPRING_GENTLE, duration: 0.6 },
  },
};

// Pulsing animation for buttons
export const pulseAnimation = {
  scale: [1, 1.02, 1],
  transition: {
    duration: 2,
    repeat: Infinity,
    ease: "easeInOut",
  },
};

// Timeline sequential animation
export const timelineVariants = {
  hidden: { opacity: 0, scale: 0.8, y: 20 },
  visible: (i) => ({
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      ...SPRING_BOUNCE,
      delay: i * 0.15,
    },
  }),
};
